import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/kit";

const ALL = ["celery", "gluten", "crustaceans", "eggs", "fish", "lupin", "milk", "molluscs", "mustard", "nuts", "peanuts", "sesame", "soya", "sulphites"];

export const dishBody = (d, patch = {}) => ({ name: d.name, category: d.category || "", notes: d.notes || "", allergens: d.allergens, description: d.description || "", may_contain: d.may_contain || [], ...patch });

export function DishDetailsDialog({ dish, onClose, onSaved }) {
  const [f, setF] = useState({ name: dish.name, category: dish.category || "", description: dish.description || "", may_contain: dish.may_contain || [] });
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put(`/dishes/${dish.id}`, dishBody(dish, { ...f, may_contain: f.may_contain.filter((a) => !dish.allergens.includes(a)) }));
      toast.success("Dish saved");
      onSaved();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="dish-details-dialog" className="max-h-[90vh] overflow-y-auto sm:max-w-lg">
        <DialogHeader><DialogTitle>Dish details</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div className="grid gap-3 sm:grid-cols-2">
            <Field label="Dish *"><input data-testid="dish-details-name" required maxLength={120} className="ka-input" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></Field>
            <Field label="Section"><input data-testid="dish-details-category" maxLength={60} className="ka-input" value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} /></Field>
          </div>
          <Field label="Description for customers" hint={`Shown on the QR menu. ${200 - f.description.length} characters left.`}>
            <textarea data-testid="dish-details-description" rows={2} maxLength={200} className="ka-input" placeholder="e.g. Beer-battered haddock, triple-cooked chips, mushy peas" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} />
          </Field>
          <Field label="May contain (traces)" hint="Allergens not in the recipe but handled nearby, e.g. shared fryer or same prep area">
            <div className="flex flex-wrap gap-1.5">{ALL.map((a) => {
              const inRecipe = dish.allergens.includes(a);
              const on = f.may_contain.includes(a);
              return <button type="button" key={a} disabled={inRecipe} data-testid={`dish-may-${a}`} title={inRecipe ? "Already in the recipe" : ""}
                onClick={() => setF({ ...f, may_contain: on ? f.may_contain.filter((x) => x !== a) : [...f.may_contain, a] })}
                className={`ka-press rounded-full border px-2.5 py-1 text-xs font-semibold capitalize disabled:cursor-not-allowed disabled:opacity-40 ${on ? "border-amber-500 bg-amber-100 text-amber-900" : "border-slate-200 text-slate-500"}`}>{a}{inRecipe ? " \u2713" : ""}</button>;
            })}</div>
          </Field>
          <button data-testid="dish-details-save" disabled={busy} className="ka-press w-full rounded-full bg-emerald-600 py-3 text-sm font-semibold text-white hover:bg-emerald-700 disabled:opacity-60">Save dish</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
